/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import UserStore from 'stores/UserStore';
import ActionDrawerStore from 'stores/ActionDrawerStore';
import AuthenticationStore from 'stores/AuthenticationStore';
import Loading from 'components/Loading/Loading';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

import styles from '../../../../ActionDrawer.module.scss';

type InjectedProps = {
  userStore: UserStore,
  actionDrawerStore: ActionDrawerStore,
  authenticationStore: AuthenticationStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'authenticationStore', 'userStore')
@observer
export default class ViewAsUserSuccess extends ComponentWithInjectedProps<{}, {}, InjectedProps> {
  componentDidMount() {
    setTimeout(() => {
      // Redirect to dashboard after 1000ms
      window.location.href = '/dashboard';
    }, 1000);
  }

  render() {
    const { userStore, t } = this.props;
    const user = userStore.activeUser;

    return userStore.userLoaded ? (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:users.messages.view_as_user_success')}</h3>
            <p>{t('general:users.messages.view_mode')}</p>
          </div>
          {user && (
            <div className={styles['loginasuser-account-details']}>
              <ul>
                <li>{`${user.first_name} ${user.last_name}`}</li>
                <li>
                  <b>{t('general:roles.labels.current_role')}</b>:{' '}
                  {t(`general:roles.${user.role_id}`)}
                </li>
              </ul>
            </div>
          )}
        </div>
        <div className={styles['action-drawer-actions']}>Redirecting...</div>
      </React.Fragment>
    ) : (
      <Loading />
    );
  }
}
